import { ReactNode } from 'react';
import { TagDisplayProvider } from './TagDisplayContext';
import { TagSelectionProvider } from './TagSelectionContext';
import { TagNavProvider } from './TagNavContext';
import { CalcPickProvider } from './CalcPickContext';

/**
 * F3 — the former 15-field mega TagContext is split into cohesive slices:
 *   - TagDisplayContext   (useTagDisplay)   — how tags render
 *   - TagSelectionContext (useTagSelection) — the table⊥block tagging axes + clicked/draft tags
 *   - TagNavContext       (useTagNav)       — footnote/exclude panel focus
 *   - CalcPickContext     (useCalcPick)     — calc-rule pick flow (F6)
 * This wrapper keeps the single public mount point so the editor/pdf/tagging views and
 * provider-based tests are unchanged; consumers read from the focused hooks.
 */
export { useTagDisplay, TagDisplayContext } from './TagDisplayContext';
export { useTagSelection, TagSelectionContext } from './TagSelectionContext';
export type { BlockSelection } from './TagSelectionContext';
export { useTagNav, TagNavContext } from './TagNavContext';

export const TagContextProvider = ({ children }: { children: ReactNode }) => (
  <TagDisplayProvider>
    <TagSelectionProvider>
      <TagNavProvider>
        <CalcPickProvider>{children}</CalcPickProvider>
      </TagNavProvider>
    </TagSelectionProvider>
  </TagDisplayProvider>
);
